import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        height: "calc(100% - 6px)",
        width: "100%",
        display: "flex",
        gap: theme.spacing(3),
    },
    side: {
        height: "100%",
        width: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    arcLabelWrapper: {
        pointerEvents: "none !important" as "none",
    },
    arcLabel: {
        fontSize: `12px !important`,
        fontFamily: "Open Sans !important",
        fontWeight: `800 !important`,
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
    rightSection: {
        flex: 1,
        overflowY: "auto",
        height: "100%",
        width: "50%",
    },
}));

export const theme = {
    tooltip: {
        container: {
            display: "none",
        },
    },
    labels: {
        text: {
            fontSize: 12,
            fontFamily: "Open Sans",
            fontWeight: 400,
        },
    },
};
